// extracted by mini-css-extract-plugin
export default {"frameContainer":"ExamChallengeFrame_frameContainer__vVsLP","questionsPicker":"ExamChallengeFrame_questionsPicker__GJc86"};